/**
 * 客服服务 Composable
 * @description 提供全局客服弹框控制和客服相关功能
 */

import { ElMessage,ElLoading } from 'element-plus'
import { useCustomerServiceStore } from '~/stores/customerService'
import { useWuKongIMStore } from '~/stores/wukongIM'
import { useGlobalStore } from '~/stores/global'
import { ResponseCode } from '~/utils/constant'
import { set } from 'lodash'

export const useCustomerService = () => {
  const customerServiceStore = useCustomerServiceStore()
  const wukongIMStore = useWuKongIMStore()
  const globalStore = useGlobalStore()

  /**
   * 打开客服弹框
   * @param exhibitionId 可选的客服uID
   */
  const openPopup = (selectServiveId?: string | number) => {
    customerServiceStore.openPopup(selectServiveId)
  }

  /**
   * 关闭客服弹框
   */
  const closePopup = () => {
    customerServiceStore.closePopup()
  }

  /**
   * 切换客服弹框显示状态
   */
  const togglePopup = () => {
    customerServiceStore.togglePopup()
  }

  /**
   * 打开在线客服聊天弹框（公用方法）
   * 注意：登录判断需要在调用前自行处理
   * @param serviceItem 可选，客服信息对象，不传则由后端分配默认客服
   * @param exhibitionId 可选，展会ID
   * @returns Promise<boolean> 是否成功
   */
  const openService = async (
    serviceItem?: any,
    exhibitionId?: string | number
  ): Promise<boolean> => {
    try {
      const loading = ElLoading.service({
        lock: true,
        text: '分配客服中...',
        background: 'rgba(0, 0, 0, 0.1)',
      })
      setTimeout(() => {
        loading.close()
      }, 5000)
      // 调用客服分配接口
      const response = await useHttp.post('/api/customer-service/consultation/consultation', {
        accessContext: {
          clientPlatform: 'PC',
          clientBrowser: navigator.userAgent,
          clientOs: navigator.platform,
          clientUserAgent: navigator.userAgent,
          entryUrl: window.location.href,
          entryUrlTitle: document.title,
          exhibitionId: exhibitionId || '',
          referrerUrl: document.referrer || ''
        },
        customerId: globalStore.user?.id,
        exhibitionId: exhibitionId,
        serviceType: serviceItem?.serviceType || 'default',
        customerServiceUid: serviceItem?.uid || '' // 不传则由后端分配默认客服
      })
      loading.close()

      if (response.code === ResponseCode.SUCCESS && response.data) {
        // 存储客服信息到全局 store
        // customerServiceStore.setCustomerServiceInfo(response.data)
        // 打开客服弹框
        customerServiceStore.openPopup(serviceItem?.uid || '')
        return true
      } else {
        ElMessage.error(response.msg || '未能分配到客服，请稍后再试')
        return false
      }
    } catch (error: any) {
      console.error('在线咨询失败:', error)
      ElMessage.error(error.message || '连接客服失败')
      return false
    }
  }

  /**
   * 获取未读消息数
   */
  const unreadCount = computed(() => wukongIMStore.unreadCount)

  /**
   * 弹框是否显示
   */
  const isVisible = computed(() => customerServiceStore.isPopupVisible)

  /**
   * 客服信息
   */
  const serviceInfo = computed(() => customerServiceStore.customerServiceInfo)

  /**
   * 会话信息
   */
  const conversationInfo = computed(() => customerServiceStore.conversationInfo)

  return {
    // 方法
    openPopup,
    closePopup,
    togglePopup,
    openService,
    // 状态
    unreadCount,
    isVisible,
    serviceInfo,
    conversationInfo,
  }
}
